// extracted by mini-css-extract-plugin
module.exports = {"BgColour":"RateAndReview_BgColour__3bnhC","Products":"RateAndReview_Products__15z5c","Features":"RateAndReview_Features__3Jywm","Margin":"RateAndReview_Margin__2dJl9"};